import { RequestStatus, defaults, entities, getAPIMethod } from 'typed/api';
import { ExtractAction, NetworkAction, action, networkAction } from './utils';

type TouchAllNotificationsAction = NetworkAction<'TOUCH_ALL_NOTIFICATIONS', { notificationFeedKey: string | null; }, void>;
interface TouchAllNotificationsCreator { (notificationFeedKey: string, sync: boolean): TouchAllNotificationsAction; (sync: true): TouchAllNotificationsAction; }
const touchAllNotifications: TouchAllNotificationsCreator = (syncOrKey: true | string) =>
    syncOrKey !== true ?
        // eslint-disable-next-line require-await
        async(dispatch: Parameters<TouchAllNotificationsAction>[0]) => {
            dispatch({ type: 'TOUCH_ALL_NOTIFICATIONS', payload: { status: RequestStatus.UNSYNCED, notificationFeedKey: syncOrKey } });
            return undefined;
        } :
        networkAction('TOUCH_ALL_NOTIFICATIONS', {}, getAPIMethod('NotificationReport', 'touchAll'));


export const
    notifications = {
        initializeFeed: (notificationFeedKey: string) => action('INITIALIZE_NOTIFICATION_FEED', { notificationFeedKey }),
        searchSlice: (notificationFeedKey: string, filter = defaults.NotificationFilter, pagination: { startID?: number; maxCount?: number; slicingOrder?: number; } = {}) =>
            networkAction(
                'SEARCH_NOTIFICATIONS_SLICE', { notificationFeedKey, filter, ...pagination }, getAPIMethod<entities.NotificationReportPaginationSlice>('NotificationReport', 'searchSlice'), filter, pagination
            ),
        touchAll: touchAllNotifications,
        dropFeed: (notificationFeedKey: string) => action('DROP_NOTIFICATION_FEED', { notificationFeedKey })
    };


export type NotificationsAction = ExtractAction<
// TODO ExtractAction should accept generic sets of action creators, not only those generated by entityActionSet
| typeof notifications['initializeFeed']
| typeof notifications['searchSlice']
| typeof notifications['touchAll']
| typeof notifications['dropFeed']
>;
